import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white flex flex-col items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute top-[-50px] left-[-50px] w-96 h-96 bg-blue-500 opacity-30 blur-3xl rounded-full"></div>
      <div className="absolute bottom-[-50px] right-[-50px] w-96 h-96 bg-purple-500 opacity-30 blur-3xl rounded-full"></div>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-center max-w-3xl"
      >
        <h1 className="text-5xl md:text-7xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          TaskVerse
        </h1>
        <p className="text-lg md:text-2xl mb-6 text-gray-300">
          <span className="text-blue-400">The ultimate task manager</span> for
          boosting your <span className="text-purple-400">productivity</span>.
        </p>
        <Link to="/dashboard">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 hover:bg-blue-700 transition-all text-white font-bold py-3 px-8 rounded-full shadow-lg text-lg"
          >
            Get Started
          </motion.button>
        </Link>
      </motion.div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl w-full text-center">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 * index, duration: 0.6 }}
            className="bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all hover:scale-105"
          >
            <feature.icon className="text-4xl text-blue-400 mb-3 mx-auto" />
            <h3 className="text-xl font-semibold mb-2 text-blue-400">
              {feature.title}
            </h3>
            <p className="text-gray-300">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

const features = [
  {
    title: "Task Management",
    description: "Create, edit, and manage tasks with ease.",
    icon: () => <i className="fas fa-tasks" />,
  },
  {
    title: "Collaboration",
    description: "Share tasks and collaborate with your team.",
    icon: () => <i className="fas fa-users" />,
  },
  {
    title: "Reminders & Alerts",
    description: "Never miss a deadline with smart notifications.",
    icon: () => <i className="fas fa-bell" />,
  },
];

export default HomePage;
